import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { FetchContext } from 'src/context/FetchContext';
import { AuthContext } from 'src/context/AuthContext';
import CloseIcon from '@mui/icons-material/Close';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CommentIcon from '@mui/icons-material/Comment';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import ViewListIcon from '@mui/icons-material/ViewList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { API_ROUTES } from 'src/services/constant';
import { getScheduleColor } from 'src/utils/scheduleColorUtils';
import CommentsModal from 'src/components/SharedComponent/Scheduling/comment_modal';
import ViewLeaveModal from 'src/components/SharedComponent/EmployeeLeaves/ViewLeaveModal';
import ViewPrebookingModal from 'src/components/SharedComponent/Prebooking/ViewPrebookingModal';
import TodoDraftUpdateModal from './tododraft_UpdateModal';
import MessageDialog from './AlertDialog';

import {
  Modal,
  Box,
  IconButton,
  Typography,
  Button,
  Stack,
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
  TextField,
  Checkbox,
  ListItemText,
  Chip,
  Grid,
  Divider,
  Alert,
  Tooltip,
  Dialog,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Backdrop,
} from '@mui/material';

const TEAL = '#65C8D0';
const TEAL_DARK = '#3DADB5';
const TEAL_LIGHT = '#E0F6F8';
const TEAL_MID = '#4BBBC4';

function AssignUserModel({ opentStatus, setUserModal, employees, schedule, handleUserAssign, allSchedules = [], onRefresh, }) {
  const [formData, setFormData] = useState({
    id: '',
    employee: [],
    groupNumber: '',
    sequenceNumber: '',
    plannedDate: null,
    workDuration: '',
    documentLink: '',
    description: '',
    comments: '',
    taskScope: '',
    costItem: '',
    estimatedHours: '',
  });

  const [errors, setErrors] = useState({});
  const [conflictWarning, setConflictWarning] = useState(false);
  const [hoursWarning, setHoursWarning] = useState(false);
  const [sequenceWarning, setSequenceWarning] = useState(false);
  const [groupHoursWarning, setGroupHoursWarning] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [costItems, setCostItems] = useState([]);
  const [openCommentModal, setCommentModal] = useState(false);
  const [commentCount, setCommentCount] = useState(0);
  const [dateLeaves, setDateLeaves] = useState([]);
  const [datePrebookings, setDatePrebookings] = useState([]);
  const [leaveModal, setLeaveModal] = useState({ open: false });
  const [prebookingModal, setPrebookingModal] = useState({ open: false });
  const [daySchedulePopup, setDaySchedulePopup] = useState(false);
  const [fetchedDayEvents, setFetchedDayEvents] = useState({});
  const [selectedGroupEvent, setSelectedGroupEvent] = useState(null);
  const [groupCommentSchedule, setGroupCommentSchedule] = useState(null);
  const [leaveWarning, setLeaveWarning] = useState([]);
  const [todoDraftModal, setTodoDraftModal] = useState(false);
  const [savingSchedule, setSavingSchedule] = useState(false);
  const [linkedDraft, setLinkedDraft] = useState(null);
  const [messageDialog, setMessageDialog] = useState({
    open: false,
    severity: 'info',
    title: '',
    message: '',
    okText: 'OK',
    cancelText: null,
    onConfirm: null,
    onCancel: null,
  });

  const groupColors = ['#65C8D0', '#4BBBC4', '#3DADB5', '#52C1CA', '#7DD4DB', '#2E9DA6'];
  const dayGroupKeys = Object.keys(fetchedDayEvents);
  const { authAxios } = useContext(FetchContext);
  const { state } = useContext(AuthContext);
  const { PRIVATE_ROUTE } = API_ROUTES;


  const [todoDraftData, setTodoDraftData] = useState({
    schedule: null,
    jobNumber: '',
    taskNumber: '',
    costItem: '',
    estimatedHours: '',
    fieldTripDate: null,
  });

  useEffect(() => {
    setFormData((f) => ({
      ...f,
      id: schedule._id,
      groupNumber: schedule.group_number,
      sequenceNumber: schedule.sequence_number,
      taskScope: schedule.task_scope_id?.name ?? '',
      costItem: Array.isArray(schedule.cost_item) ? schedule.cost_item[0] || '' : schedule.cost_item || '',
      plannedDate: schedule.planned_date ? dayjs(schedule.planned_date.split('T')[0]) : null,
      documentLink: schedule.document_link,
      description: schedule.description || '',
      employee: schedule.assigned_members,
      estimatedHours: schedule.estimated_hours,
    }));

    setCommentCount(Array.isArray(schedule.comments) ? schedule.comments.length : 0);
    if (schedule.planned_date) {
      fetchDateInfo(dayjs(schedule.planned_date.split('T')[0]));
    }
    getCostItems();
    checkConflict(
      schedule.assigned_members,
      schedule.planned_date ? dayjs(schedule.planned_date.split('T')[0]) : null,
      schedule.group_number,
      schedule.sequence_number,
      schedule.estimated_hours,
      Array.isArray(schedule.cost_item) ? schedule.cost_item[0] || '' : schedule.cost_item || ''
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const loadLinkedDraft = async () => {
      try {
        const response = await authAxios.get(
          PRIVATE_ROUTE.GET_TODO_DRAFTS_FOR_SCHEDULE,
          {
            params: {
              job_id: schedule.job_id.number_str,
              task_id: schedule.task._id,
              schedule_id: schedule._id,
              linkedOnly: 'all',
            },
          }
        );

        setLinkedDraft(response?.data?.data?.[0] || null);
      } catch (err) {
        console.error(err);
        setLinkedDraft(null);
      }
    };

    if (opentStatus) {
      loadLinkedDraft();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opentStatus, schedule]);

  const handleUnlinkDraft = async () => {
    if (!linkedDraft) return;

    const draftStatus = String(
      linkedDraft.status || ''
    ).toLowerCase().trim();

    // For Open / Ready for Drafting, unlink immediately.
    // For all other statuses, ask the user for explicit confirmation.
    if (
      draftStatus !== 'open' &&
      draftStatus !== 'ready for drafting'
    ) {
      setMessageDialog({
        open: true,
        severity: 'warning',
        title: 'Confirm Unlink Draft',
        message: (
          <>
            This Todo Draft is currently in{' '}
            <strong>"{linkedDraft.status}"</strong> status.
            <br />
            <br />
            Unlinking the draft will remove its association with this
            schedule and reset the draft to <strong>"Open"</strong>.
            <br />
            <br />
            Are you sure you want to continue?
          </>
        ),
        okText: 'Yes, Unlink',
        cancelText: 'Cancel',
        onConfirm: async () => {
          setMessageDialog(resetMessageDialog());

          try {
            setSavingSchedule(true);

            const response = await authAxios.post(
              `${PRIVATE_ROUTE.EDIT_TODO_DRAFT}${linkedDraft._id}`,
              {
                schedule_id: null,
                field_trip_date: null,
                status: 'open',
                urgency: '',
                assigned_members: [],
                skipUpdatedAtCheck: true,
              }
            );

            setSavingSchedule(false);

            if (response.data.statusCode === 200) {
              setLinkedDraft(null);
              onRefresh?.();

              setMessageDialog({
                open: true,
                severity: 'success',
                title: 'Success',
                message: 'Todo Draft has been unlinked successfully.',
                okText: 'OK',
              });
            } else {
              setMessageDialog({
                open: true,
                severity: 'error',
                title: 'Error',
                message: response.data.message,
                okText: 'OK',
              });
            }
          } catch (err) {
            setSavingSchedule(false);

            setMessageDialog({
              open: true,
              severity: 'error',
              title: 'Error',
              message:
                err?.response?.data?.message ||
                'Failed to unlink Todo Draft.',
              okText: 'OK',
            });
          }
        },
        onCancel: () => {
          setMessageDialog(resetMessageDialog());
        },
      });

      return;
    }

    // Open / Ready for Drafting → unlink immediately
    try {
      setSavingSchedule(true);

      const response = await authAxios.post(
        `${PRIVATE_ROUTE.EDIT_TODO_DRAFT}${linkedDraft._id}`,
        {
          schedule_id: null,
          field_trip_date: null,
          status: 'open',
          urgency: '',
          assigned_members: [],
          skipUpdatedAtCheck: true,
        }
      );

      setSavingSchedule(false);

      if (response.data.statusCode === 200) {
        setLinkedDraft(null);
        onRefresh?.();

        setMessageDialog({
          open: true,
          severity: 'success',
          title: 'Success',
          message: 'Todo Draft has been unlinked successfully.',
          okText: 'OK',
        });
      } else {
        setMessageDialog({
          open: true,
          severity: 'error',
          title: 'Error',
          message: response.data.message,
          okText: 'OK',
        });
      }
    } catch (err) {
      setSavingSchedule(false);

      setMessageDialog({
        open: true,
        severity: 'error',
        title: 'Error',
        message:
          err?.response?.data?.message ||
          'Failed to unlink Todo Draft.',
        okText: 'OK',
      });
    }
  };


  const fetchDateInfo = async (date) => {
    if (!date) {
      setDateLeaves([]);
      setDatePrebookings([]);
      setFetchedDayEvents({});
      return;
    }
    const dateStr = date.format('YYYY-MM-DD');
    const year = date.year();
    const month = date.month() + 1;

    const [leavesResult, prebookingsResult, schedulesResult] = await Promise.allSettled([
      authAxios.get(`${PRIVATE_ROUTE.GET_EMPLOYEE_LEAVES}?year=${year}&month=${month}`),
      authAxios.get(`${PRIVATE_ROUTE.GET_PREBOOKING}?year=${year}&month=${month}`),
      authAxios.get(`${PRIVATE_ROUTE.GET_SCHEDULE}?startDate=${dateStr}&endDate=${dateStr}&per_page=200`),
    ]);

    if (leavesResult.status === 'fulfilled') {
      setDateLeaves(
        (leavesResult.value.data?.data ?? []).filter((l) => {
          const from = l.date_from?.substring(0, 10);
          if (!from) return false;
          const to = l.date_to?.substring(0, 10);
          if (!to) return from === dateStr;
          return dateStr >= from && dateStr <= to;
        })
      );
    } else {
      setDateLeaves([]);
    }

    if (prebookingsResult.status === 'fulfilled') {
      setDatePrebookings(
        (prebookingsResult.value.data?.data ?? []).filter((p) => p.date?.substring(0, 10) === dateStr)
      );
    } else {
      setDatePrebookings([]);
    }

    if (schedulesResult.status === 'fulfilled') {
      const groups = {};

      (schedulesResult.value.data?.data ?? [])
        .filter((s) => s.planned_date?.split('T')[0] === dateStr)
        .forEach((s) => {
          const g = String(s.group_number);
          if (!groups[g]) groups[g] = [];
          groups[g].push(s);
        });

      setFetchedDayEvents(groups);
    } else {
      setFetchedDayEvents({});
    }
  };

  useEffect(() => {
    fetchDateInfo(formData.plannedDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.plannedDate]);

  useEffect(() => {
    checkEmployeeLeave(formData.employee);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateLeaves, formData.employee]);

  const getCostItems = async () => {
    try {
      const response = await authAxios.get(`${PRIVATE_ROUTE?.GET_LABOUR_COST_ITEMS}`);
      setCostItems(response?.data?.data || []);
    } catch (e) {
      console.error('Failed to fetch labour cost items', e);
    }
  };

  // const validate = () => {
  //   const newErrors = {};
  //   if (!formData.employee.length) newErrors.employee = 'At least one employee is required';
  //   if (!formData.taskScope) newErrors.taskScope = 'Task scope is required';
  //   if (!formData.costItem) newErrors.costItem = 'Cost item is required';
  //   if (!formData.groupNumber) newErrors.groupNumber = 'Group number is required';
  //   if (!formData.sequenceNumber) newErrors.sequenceNumber = 'Sequence number is required';
  //   if (!formData.plannedDate) newErrors.plannedDate = 'Planned date is required';
  //   else if (formData.plannedDate.isBefore(dayjs().startOf('day')))
  //     newErrors.plannedDate = 'Planned Date must be today or a future date.';
  //   if (!formData.estimatedHours) newErrors.estimatedHours = 'Estimated hours is required';

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  // const validate = () => {
  //   const newErrors = {};

  //   const normalizedCostItem = String(formData.costItem || '')
  //     .toLowerCase()
  //     .trim();

  //   if (
  //     normalizedCostItem === '1/2 survey crew' &&
  //     formData.employee.length < 2
  //   ) {
  //     newErrors.employee =
  //       '1/2 Survey Crew requires at least 2 employees.';
  //   }
  //   else if (
  //     normalizedCostItem !== '1/2 survey crew' &&
  //     formData.employee.length !== 1
  //   ) {
  //     newErrors.employee =
  //       normalizedCostItem + ' requires exactly 1 employee.';
  //   }
  //   else if (formData.employee.length === 0) {
  //     newErrors.employee = 'At least one employee is required.';
  //   }

  //   if (!formData.taskScope) newErrors.taskScope = 'Task scope is required';
  //   if (!formData.costItem) newErrors.costItem = 'Cost item is required';
  //   if (!formData.groupNumber) newErrors.groupNumber = 'Group number is required';
  //   if (!formData.sequenceNumber) newErrors.sequenceNumber = 'Sequence number is required';

  //   if (!formData.plannedDate) {
  //     newErrors.plannedDate = 'Planned date is required';
  //   } else if (formData.plannedDate.isBefore(dayjs().startOf('day'))) {
  //     newErrors.plannedDate = 'Planned Date must be today or a future date.';
  //   }

  //   if (!formData.estimatedHours) {
  //     newErrors.estimatedHours = 'Estimated hours is required';
  //   }

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const validate = () => {
    const newErrors = {};

    const normalizedCostItem = String(formData.costItem || '')
      .toLowerCase()
      .trim();

    if (
      normalizedCostItem === '1/2 survey crew' &&
      formData.employee.length < 2
    ) {
      newErrors.employee =
        '1/2 Survey Crew requires at least 2 employees.';
    } else if (
      normalizedCostItem !== '1/2 survey crew' &&
      formData.employee.length !== 1
    ) {
      newErrors.employee =
        normalizedCostItem + ' requires exactly 1 employee.';
    }

    // Validate cost item compatibility within the same group
    const groupCostItemError = validateGroupCostItem(
      formData.costItem,
      formData.plannedDate,
      formData.groupNumber
    );

    if (groupCostItemError) {
      newErrors.costItem = groupCostItemError;
    }

    if (!formData.taskScope) newErrors.taskScope = 'Task scope is required';
    if (!formData.costItem) newErrors.costItem = 'Cost item is required';
    if (!formData.groupNumber) newErrors.groupNumber = 'Group number is required';
    if (!formData.sequenceNumber) newErrors.sequenceNumber = 'Sequence number is required';

    if (!formData.plannedDate) {
      newErrors.plannedDate = 'Planned date is required';
    } else if (formData.plannedDate.isBefore(dayjs().startOf('day'))) {
      newErrors.plannedDate = 'Planned Date must be today or a future date.';
    }

    if (!formData.estimatedHours) {
      newErrors.estimatedHours = 'Estimated hours is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isHalfCrew = (costItem) => {
    const item = Array.isArray(costItem) ? costItem[0] || '' : costItem || '';
    return item.toLowerCase().trim() === '1/2 survey crew';
  };

  const validateGroupCostItem = (costItem, plannedDate, groupNumber) => {
    if (!plannedDate || !groupNumber || !costItem) return '';

    const dateStr = plannedDate.format('YYYY-MM-DD');
    const selectedIsHalfCrew = isHalfCrew(costItem);

    // Get existing schedules in the same date and group.
    // Exclude the schedule currently being edited.
    const sameGroupSchedules = allSchedules.filter(
      (s) =>
        String(s._id) !== String(schedule._id) &&
        s.planned_date?.split('T')[0] === dateStr &&
        Number(s.group_number) === Number(groupNumber)
    );

    const hasHalfCrew = sameGroupSchedules.some((s) =>
      isHalfCrew(s.cost_item)
    );

    const hasOtherCostItem = sameGroupSchedules.some(
      (s) => !isHalfCrew(s.cost_item)
    );

    if (selectedIsHalfCrew && hasOtherCostItem) {
      return 'This group already contains other cost items. 1/2 Survey Crew cannot be added to this group.';
    }

    if (!selectedIsHalfCrew && hasHalfCrew) {
      return 'This group already contains 1/2 Survey Crew. Only 1/2 Survey Crew records are allowed in this group.';
    }

    return '';
  };

  const effectiveHours = (hours, costItem) => (parseFloat(hours) || 0) * (isHalfCrew(costItem) ? 0.5 : 1);

  const checkConflict = (employees, plannedDate, groupNumber, sequenceNumber, estimatedHours, costItem) => {
    if (!plannedDate || !groupNumber) {
      setConflictWarning(false);
      setHoursWarning(false);
      setSequenceWarning(false);
      setGroupHoursWarning(false);
      return;
    }
    const dateStr = plannedDate.format('YYYY-MM-DD');

    // Employee-dependent checks
    if (employees.length) {
      const conflictingEmployees = employees
        .filter((emp) =>
          allSchedules.some(
            (s) =>
              String(s._id) !== String(schedule._id) &&
              s.planned_date?.split('T')[0] === dateStr &&
              Number(s.group_number) !== Number(groupNumber) &&
              s.assigned_members?.some((m) => m._id === emp._id)
          )
        )
        .map((emp) => `${emp.first_name} ${emp.last_name}`);

      setConflictWarning(conflictingEmployees.length ? conflictingEmployees : false);
      const overloadedEmployees = employees
        .filter((emp) => {
          const totalHours = allSchedules
            .filter(
              (s) =>
                String(s._id) !== String(schedule._id) &&
                s.planned_date?.split('T')[0] === dateStr &&
                s.assigned_members?.some((m) => m._id === emp._id)
            )
            .reduce((sum, s) => sum + effectiveHours(s.estimated_hours, s.cost_item), 0);

          // Include current schedule being edited as well
          const currentHours = effectiveHours(estimatedHours, costItem);

          return totalHours + currentHours > 8;
        })
        .map((emp) => `${emp.first_name} ${emp.last_name}`);
      setHoursWarning(overloadedEmployees.length ? overloadedEmployees : false);
    } else {
      setConflictWarning(false);
      setHoursWarning(false);
    }

    // Sequence check (depends only on date + group + sequence)
    setSequenceWarning(
      sequenceNumber
        ? allSchedules.some(
          (s) =>
            String(s._id) !== String(schedule._id) &&
            s.planned_date?.split('T')[0] === dateStr &&
            Number(s.group_number) === Number(groupNumber) &&
            Number(s.sequence_number) === Number(sequenceNumber)
        )
        : false
    );

    // Group hours check — sum other schedules in same group + current document's estimated hours
    // Schedules with "1/2 Survey Crew" cost item count as half hours
    const otherGroupHours = allSchedules
      .filter(
        (s) =>
          String(s._id) !== String(schedule._id) &&
          s.planned_date?.split('T')[0] === dateStr &&
          Number(s.group_number) === Number(groupNumber)
      )
      .reduce((sum, s) => sum + effectiveHours(s.estimated_hours, s.cost_item), 0);
    const groupTotalHours = otherGroupHours + effectiveHours(estimatedHours, costItem);
    setGroupHoursWarning(groupTotalHours > 8);
  };

  const getNextAvailableSequence = (plannedDate, groupNumber) => {
    if (!plannedDate || !groupNumber) return '';

    const dateStr = plannedDate.format('YYYY-MM-DD');

    const usedSequences = allSchedules
      .filter(
        (s) =>
          String(s._id) !== String(schedule._id) &&
          s.planned_date?.split('T')[0] === dateStr &&
          Number(s.group_number) === Number(groupNumber)
      )
      .map((s) => Number(s.sequence_number))
      .filter(Boolean)
      .sort((a, b) => a - b);

    // Find first missing number starting from 1
    for (let i = 1; i <= 10; i += 1) {
      if (!usedSequences.includes(i)) {
        return i;
      }
    }

    // If 1..10 all used, return next number
    return usedSequences.length + 1;
  };

  const checkEmployeeLeave = (selectedEmployees) => {
    if (!selectedEmployees?.length || !dateLeaves?.length) {
      setLeaveWarning([]);
      return;
    }

    const employeesOnLeave = selectedEmployees.filter((emp) =>
      dateLeaves.some((leave) => leave.employee_id?._id === emp._id)
    );

    setLeaveWarning(employeesOnLeave);
  };

  const handleChange = (field, value) => {
    const updated = { ...formData, [field]: value };

    if ((field === 'plannedDate' || field === 'groupNumber') && updated.plannedDate && updated.groupNumber) {
      const dateStr = updated.plannedDate.format('YYYY-MM-DD');

      const sameGroupSchedules = allSchedules.filter(
        (s) => s.planned_date?.split('T')[0] === dateStr && Number(s.group_number) === Number(updated.groupNumber)
      );

      const existingSchedule = sameGroupSchedules.find(
        (s) => Array.isArray(s.assigned_members) && s.assigned_members.length > 0
      );

      // Auto populate employees if group already exists
      updated.employee = existingSchedule ? existingSchedule.assigned_members : [];

      // Auto populate sequence number
      updated.sequenceNumber = getNextAvailableSequence(updated.plannedDate, updated.groupNumber);

      // FIX: refresh leave warning for auto-populated employees
      checkEmployeeLeave(updated.employee);
    }

    // Clear employees and sequence if date/group empty
    if ((field === 'plannedDate' || field === 'groupNumber') && (!updated.plannedDate || !updated.groupNumber)) {
      updated.employee = [];
      updated.sequenceNumber = '';
      setLeaveWarning([]);
    }

    setFormData(updated);

    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: undefined,
        sequenceNumber: undefined,
        ...(updated.employee?.length ? { employee: undefined } : {}),
      }));
    }

    checkConflict(
      updated.employee,
      updated.plannedDate,
      updated.groupNumber,
      updated.sequenceNumber,
      updated.estimatedHours,
      updated.costItem
    );
  };


  const resetMessageDialog = () => ({
    open: false,
    severity: '',
    title: '',
    message: '',
    okText: 'OK',
    cancelText: null,
    onConfirm: null,
    onCancel: null,
  });


  const showScheduleAndDraftSuccess = () => {
    setMessageDialog({
      open: true,
      severity: 'success',
      title: 'Success',
      message: 'Schedule and Todo Draft updated successfully.',
      okText: 'OK',
      cancelText: null,
      onConfirm: () => {
        setMessageDialog(resetMessageDialog());
        setUserModal(false);
      },
      onCancel: null,
    });
  };

  const handleUpdateLinkedDraft = async (currentLinkedDraft) => {
    if (!currentLinkedDraft) return;

    try {
      setSavingSchedule(true);

      const response = await authAxios.post(
        `${PRIVATE_ROUTE.EDIT_TODO_DRAFT}${currentLinkedDraft._id}`,
        {
          field_trip_date: formData.plannedDate
            ? formData.plannedDate.format('YYYY-MM-DD')
            : null,
          status: 'ready for drafting',
          assigned_members: [],
          skipUpdatedAtCheck: true,
        }
      );

      setSavingSchedule(false);

      if (response?.data?.statusCode === 200) {
        setMessageDialog(resetMessageDialog());

        onRefresh?.();

        setMessageDialog({
          open: true,
          severity: 'success',
          title: 'Success',
          message: 'Schedule and Todo Draft updated successfully.',
          okText: 'OK',
          cancelText: null,
          onConfirm: () => {
            setMessageDialog(resetMessageDialog());
            setUserModal(false);
          },
          onCancel: null,
        });
      } else {
        setMessageDialog({
          open: true,
          severity: 'error',
          title: 'Todo Draft Update Failed',
          message:
            response?.data?.message ||
            'The linked Todo Draft could not be updated.',
          okText: 'OK',
          cancelText: null,
          onConfirm: () => {
            setMessageDialog(resetMessageDialog());
          },
          onCancel: null,
        });
      }
    } catch (err) {
      console.error('Error updating linked Todo Draft:', err);

      setSavingSchedule(false);

      setMessageDialog({
        open: true,
        severity: 'error',
        title: 'Todo Draft Update Failed',
        message:
          err?.response?.data?.message ||
          'Failed to update the linked Todo Draft. Please try again.',
        okText: 'OK',
        cancelText: null,
        onConfirm: () => {
          setMessageDialog(resetMessageDialog());
        },
        onCancel: null,
      });
    }
  };



  const doSave = async () => {
    setSavingSchedule(true);
    setConfirmOpen(false);

    const finish = () => {
      setSavingSchedule(false);
    };

    const showError = (message) => {
      finish();

      setMessageDialog({
        open: true,
        severity: 'error',
        title: 'Error',
        message,
        okText: 'OK',
      });
    };

    try {
      const selectedEmployees = formData.employee.map((emp) => emp._id);

      // STEP 1: Update Schedule
      const scheduleResponse = await handleUserAssign(formData.id, {
        group_number: formData.groupNumber,
        sequence_number: formData.sequenceNumber,
        planned_date: formData.plannedDate
          ? formData.plannedDate.format('YYYY-MM-DD')
          : null,
        document_link: formData.documentLink,
        description: formData.description,
        assigned_members: selectedEmployees,
        estimated_hours: formData.estimatedHours,
        task_scope_id: formData.taskScope,
        cost_item: formData.costItem,
      });

      if (!scheduleResponse) {
        throw new Error('Failed to update schedule.');
      }

      // STEP 2: Find linked Todo Draft
      let currentLinkedDraft = null;

      try {
        const draftResponse = await authAxios.get(
          PRIVATE_ROUTE.GET_TODO_DRAFTS_FOR_SCHEDULE,
          {
            params: {
              job_id: schedule.job_id.number_str,
              task_id: schedule.task._id,
              schedule_id: schedule._id,
              linkedOnly: 'all',
            },
          }
        );

        currentLinkedDraft = draftResponse?.data?.data?.[0] || null;
        setLinkedDraft(currentLinkedDraft);
      } catch (err) {
        console.error('Error fetching linked Todo Draft:', err);
      }

      // STEP 3: Linked Todo Draft exists
      if (currentLinkedDraft) {
        const draftStatus = String(
          currentLinkedDraft.status || ''
        ).toLowerCase().trim();

        // OPEN / READY FOR DRAFTING
        // Automatically update the linked Todo Draft.
        if (
          draftStatus === 'open' ||
          draftStatus === 'ready for drafting'
        ) {
          try {
            const response = await authAxios.post(
              `${PRIVATE_ROUTE.EDIT_TODO_DRAFT}${currentLinkedDraft._id}`,
              {
                field_trip_date: formData.plannedDate
                  ? formData.plannedDate.format('YYYY-MM-DD')
                  : null,
                description: formData.description,
                skipUpdatedAtCheck: true,
              }
            );

            if (response.data.statusCode !== 200) {
              showError(
                `Schedule updated successfully, but the linked Todo Draft could not be updated. Reason: ${response.data.message}`
              );
              return;
            }
          } catch (err) {
            console.error('Error updating Todo Draft:', err);

            showError(
              'Oops Something went wrong. Please try again or contact support if the issue persists.'
            );
            return;
          }

          finish();
          showScheduleAndDraftSuccess();
          return;
        }

        // LINKED DRAFT EXISTS BUT STATUS CANNOT BE UPDATED AUTOMATICALLY
        finish();

        setMessageDialog({
          open: true,
          severity: 'error',
          title: 'Todo Draft Cannot Be Updated Automatically',
          message: (
            <>
              The linked Todo Draft is currently in{' '}
              <strong>"{currentLinkedDraft.status}"</strong> status and
              cannot be updated automatically.
              <br />
              <br />
              Would you like to update the Todo Draft anyway?
            </>
          ),
          okText: 'Update Draft',
          cancelText: 'Close',

          // Update Draft
          onConfirm: async () => {
            await handleUpdateLinkedDraft(currentLinkedDraft);
          },

          // Close
          onCancel: () => {
            setMessageDialog(resetMessageDialog());
            setUserModal(false);
          },
        });

        return;


      }

      // STEP 4: No linked Todo Draft
      // Open Todo Draft creation/update modal.
      setTodoDraftData({
        jobNumber: schedule.job_id?.number_str,
        taskNumber: schedule.task?.number_str,
        fieldTripDate: formData.plannedDate,
        costItem: formData.costItem,
        estimatedHours: formData.estimatedHours,
        description: formData.description,
      });

      finish();
      setTodoDraftModal(true);
    } catch (err) {
      console.error('doSave()', err);

      showError(
        err?.response?.data?.message ||
        err?.message ||
        'An unexpected error occurred while saving.'
      );
    }
  };

  const handleDelete = (name) => {
    const updated = formData.employee.filter((emp) => emp !== name);
    setFormData({ ...formData, employee: updated });
    if (updated.length > 0) setErrors({ ...errors, employee: undefined });
  };

  let selected_employees = [];
  formData.employee.forEach((emp) => {
    selected_employees.push(emp._id);
  });

  const fieldLabelSx = {
    fontSize: '0.78rem',
    fontWeight: 600,
    color: '#555',
    mb: 0.5,
  };

  const plannedDateStr = formData.plannedDate ? formData.plannedDate.format('YYYY-MM-DD') : '';
  return (
    <>
      <Dialog
        open={daySchedulePopup}
        onClose={() => setDaySchedulePopup(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { borderRadius: 2, overflow: 'hidden', maxHeight: '80vh', display: 'flex', flexDirection: 'column' },
        }}
      >
        <Box
          sx={{
            background: '#3DADB5',
            color: '#fff',
            px: 2.5,
            py: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0,
          }}
        >
          <Box>
            <Typography sx={{ opacity: 0.85, fontSize: '0.7rem', letterSpacing: 1, fontWeight: 600 }}>
              DAY SCHEDULE
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
              {plannedDateStr}
            </Typography>
            <Typography sx={{ opacity: 0.85, fontSize: '0.78rem' }}>
              {dayGroupKeys.length} group{dayGroupKeys.length !== 1 ? 's' : ''}
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => setDaySchedulePopup(false)} sx={{ color: '#fff' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Box sx={{ overflowY: 'auto', flex: 1, p: 1.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
          {dayGroupKeys.map((group, index) => {
            const color = groupColors[index % groupColors.length];
            const members = fetchedDayEvents[group][0]?.assigned_members
              ? fetchedDayEvents[group][0].assigned_members.map((m) => `${m.first_name} ${m.last_name}`).join(', ')
              : '';
            return (
              <button
                key={group}
                type="button"
                onClick={() => setSelectedGroupEvent({ group, event: fetchedDayEvents[group] })}
                style={{
                  width: '100%',
                  display: 'block',
                  background: `${color}18`,
                  borderLeft: `4px solid ${color}`,
                  borderTop: 'none',
                  borderRight: 'none',
                  borderBottom: 'none',
                  borderRadius: '0 6px 6px 0',
                  padding: '10px 12px',
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: '14px', fontWeight: '700', color }}>Group {group}</span>
                  <span
                    style={{
                      background: color,
                      color: '#fff',
                      borderRadius: '10px',
                      padding: '1px 8px',
                      fontSize: '12px',
                      fontWeight: '700',
                    }}
                  >
                    {fetchedDayEvents[group].length}
                  </span>
                </div>
                {members && <div style={{ fontSize: '12px', color: '#555', marginTop: '4px' }}>{members}</div>}
              </button>
            );
          })}
        </Box>
      </Dialog>

      {/* Group Detail Dialog */}
      <Dialog
        open={Boolean(selectedGroupEvent)}
        onClose={() => setSelectedGroupEvent(null)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { borderRadius: 2, overflow: 'hidden', maxHeight: '80vh', display: 'flex', flexDirection: 'column' },
        }}
      >
        {selectedGroupEvent &&
          (() => {
            const groupColor = '#65C8D0';
            const groupMembers = [
              ...new Set(
                (selectedGroupEvent.event ?? []).flatMap((e) =>
                  (e.assigned_members ?? []).map((m) => `${m.first_name} ${m.last_name}`)
                )
              ),
            ];
            return (
              <>
                <Box
                  sx={{
                    background: groupColor,
                    color: '#fff',
                    px: 2.5,
                    py: 1.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexShrink: 0,
                  }}
                >
                  <Box>
                    <Typography sx={{ opacity: 0.85, fontSize: '0.7rem', letterSpacing: 1, fontWeight: 600 }}>
                      SCHEDULE DETAILS
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                      Group {selectedGroupEvent.group}
                    </Typography>
                    <Typography sx={{ opacity: 0.85, fontSize: '0.78rem' }}>
                      {selectedGroupEvent.event?.length} task{selectedGroupEvent.event?.length !== 1 ? 's' : ''}
                    </Typography>
                    {groupMembers.length > 0 && (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                        {groupMembers.map((name) => (
                          <Box
                            key={name}
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              background: 'rgba(255,255,255,0.18)',
                              border: '1px solid rgba(255,255,255,0.35)',
                              borderRadius: '20px',
                              px: 1,
                              py: '2px',
                            }}
                          >
                            <Typography sx={{ fontSize: '0.7rem', fontWeight: 600, color: '#fff', lineHeight: 1 }}>
                              {name}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                  <IconButton size="small" onClick={() => setSelectedGroupEvent(null)} sx={{ color: '#fff' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
                <Box sx={{ overflowY: 'auto', flex: 1 }}>
                  {[...selectedGroupEvent.event]
                    .sort((a, b) => (a.sequence_number ?? 0) - (b.sequence_number ?? 0))
                    .map((s, index) => (
                      <Accordion
                        key={index}
                        disableGutters
                        elevation={0}
                        sx={{ borderBottom: '1px solid #eee', '&:before': { display: 'none' } }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon sx={{ color: groupColor }} />}
                          sx={{
                            px: 2,
                            py: 0.75,
                            backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#fff',
                            '&:hover': { backgroundColor: '#EAF8F9' },
                            minHeight: 'unset',
                            '& .MuiAccordionSummary-content': { margin: '6px 0' },
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                            <Box
                              sx={{
                                background: getScheduleColor(s.estimated_hours, s.cost_item),
                                color: '#fff',
                                borderRadius: '4px',
                                px: 0.75,
                                py: 0.25,
                                fontSize: '0.7rem',
                                fontWeight: 700,
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                              }}
                            >
                              {s.job_id?.number_str}
                            </Box>
                            <Typography
                              sx={{
                                fontSize: '0.78rem',
                                fontWeight: 600,
                                color: '#3DADB5',
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                              }}
                            >
                              {s.job_id?.locations?.[0]?.city || ''}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: '0.82rem',
                                fontWeight: 600,
                                color: '#333',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {(s.project_managers ?? []).map((m) => `${m.first_name} ${m.last_name}`).join(', ')}
                            </Typography>
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails sx={{ px: 2, py: 1.5, backgroundColor: '#fff' }}>
                          <Table size="small">
                            <TableBody>
                              {[
                                ['Task Number', s.task?.number_str],
                                ['Job Number', s.job_id?.number_str],
                                ['Client', s.client_id?.company_name],
                                [
                                  'Location',
                                  [s.task?.client_location_id, s.job_id?.locations?.[0]?.city]
                                    .filter(Boolean)
                                    .join(', '),
                                ],
                                ['Task Scope', s.task_scope_id?.name ?? ''],
                                ['Cost Item', s.cost_item?.[0]],
                              ].map(([label, value]) => (
                                <TableRow
                                  key={label}
                                  sx={{
                                    '&:last-child td': { borderBottom: 0 },
                                    '&:hover': { backgroundColor: '#EAF8F9' },
                                  }}
                                >
                                  <TableCell
                                    sx={{
                                      color: '#555',
                                      fontWeight: 600,
                                      fontSize: '0.78rem',
                                      backgroundColor: '#E0F6F8',
                                      borderRight: '1px solid #e0e0e0',
                                      width: '38%',
                                      py: 0.75,
                                    }}
                                  >
                                    {label}
                                  </TableCell>
                                  <TableCell sx={{ fontSize: '0.78rem', color: '#222', py: 0.75 }}>
                                    {value || '—'}
                                  </TableCell>
                                </TableRow>
                              ))}
                              <TableRow sx={{ '&:hover': { backgroundColor: '#EAF8F9' } }}>
                                <TableCell
                                  sx={{
                                    color: '#555',
                                    fontWeight: 600,
                                    fontSize: '0.78rem',
                                    backgroundColor: '#E0F6F8',
                                    borderRight: '1px solid #e0e0e0',
                                    width: '38%',
                                    py: 0.75,
                                  }}
                                >
                                  Document Link
                                </TableCell>
                                <TableCell sx={{ fontSize: '0.78rem', py: 0.75 }}>
                                  {s.document_link ? (
                                    <a
                                      href={
                                        /^https?:\/\//i.test(s.document_link)
                                          ? s.document_link
                                          : `https://${s.document_link}`
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: '#3DADB5', fontWeight: 600, wordBreak: 'break-all' }}
                                    >
                                      {s.document_link}
                                    </a>
                                  ) : (
                                    '—'
                                  )}
                                </TableCell>
                              </TableRow>
                              <TableRow sx={{ '&:hover': { backgroundColor: '#EAF8F9' } }}>
                                <TableCell
                                  sx={{
                                    color: '#555',
                                    fontWeight: 600,
                                    fontSize: '0.78rem',
                                    backgroundColor: '#E0F6F8',
                                    borderRight: '1px solid #e0e0e0',
                                    width: '38%',
                                    py: 0.75,
                                    borderBottom: 0,
                                  }}
                                >
                                  Description
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: '0.78rem',
                                    color: '#222',
                                    py: 0.75,
                                    borderBottom: 0,
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word',
                                  }}
                                >
                                  {s.description || '—'}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                            <Button
                              size="small"
                              variant={Array.isArray(s.comments) && s.comments.length > 0 ? 'contained' : 'text'}
                              startIcon={<CommentIcon sx={{ fontSize: '14px !important' }} />}
                              onClick={() => setGroupCommentSchedule(s)}
                              sx={
                                Array.isArray(s.comments) && s.comments.length > 0
                                  ? {
                                    backgroundColor: '#65C8D0',
                                    color: '#fff',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    fontSize: '0.75rem',
                                    '&:hover': { backgroundColor: '#3DADB5' },
                                  }
                                  : {
                                    color: TEAL_DARK,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    '&:hover': { backgroundColor: TEAL_LIGHT },
                                  }
                              }
                            >
                              {Array.isArray(s.comments) && s.comments.length > 0
                                ? `Comments (${s.comments.length})`
                                : 'Comments'}
                            </Button>
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                </Box>
              </>
            );
          })()}
      </Dialog>

      <ViewLeaveModal
        open={leaveModal.open}
        onClose={() => setLeaveModal({ open: false })}
        date={plannedDateStr}
        records={dateLeaves}
        isAdminOrManager
      />
      <ViewPrebookingModal
        open={prebookingModal.open}
        onClose={() => setPrebookingModal({ open: false })}
        date={plannedDateStr}
        records={datePrebookings}
      />
      {openCommentModal && (
        <CommentsModal
          opentStatus={openCommentModal}
          setCommentModal={setCommentModal}
          onCommentAdded={() => setCommentCount((c) => c + 1)}
          selectedSchedule={schedule}
          user={state.user}
        />
      )}
      {groupCommentSchedule && (
        <CommentsModal
          opentStatus={Boolean(groupCommentSchedule)}
          setCommentModal={() => setGroupCommentSchedule(null)}
          selectedSchedule={groupCommentSchedule}
          user={state.user}
        />
      )}
      <Modal open={opentStatus}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95vw', sm: 780 },
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '90vh',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              background: `linear-gradient(135deg, ${TEAL} 0%, ${TEAL_DARK} 100%)`,
              px: 3,
              py: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexShrink: 0,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <PeopleAltIcon sx={{ color: '#fff', fontSize: 22 }} />
              <Box>
                <Typography
                  sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.68rem', letterSpacing: 1.2, fontWeight: 600 }}
                >
                  SCHEDULING
                </Typography>
                <Typography variant="h6" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.2 }}>
                  Assign User
                </Typography>
                <Box sx={{ display: 'flex', gap: 0.75, mt: 0.75, flexWrap: 'wrap' }}>
                  {schedule.job_id?.number_str && (
                    <Box
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 0.5,
                        backgroundColor: getScheduleColor(schedule.estimated_hours, schedule.cost_item),
                        borderRadius: '20px',
                        px: 1.25,
                        py: 0.25,
                      }}
                    >
                      <Typography
                        sx={{
                          color: 'rgba(255,255,255,0.75)',
                          fontSize: '0.62rem',
                          fontWeight: 700,
                          letterSpacing: 0.8,
                        }}
                      >
                        JOB
                      </Typography>
                      <Typography sx={{ color: '#fff', fontSize: '0.72rem', fontWeight: 800 }}>
                        {schedule.job_id.number_str}
                      </Typography>
                    </Box>
                  )}
                  {schedule.task?.number_str && (
                    <Box
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 0.5,
                        backgroundColor: 'rgba(255,255,255,0.18)',
                        border: '1px solid rgba(255,255,255,0.4)',
                        borderRadius: '20px',
                        px: 1.25,
                        py: 0.25,
                      }}
                    >
                      <Typography
                        sx={{
                          color: 'rgba(255,255,255,0.75)',
                          fontSize: '0.62rem',
                          fontWeight: 700,
                          letterSpacing: 0.8,
                        }}
                      >
                        TASK
                      </Typography>
                      <Typography sx={{ color: '#fff', fontSize: '0.72rem', fontWeight: 800 }}>
                        {schedule.task.number_str}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
            <IconButton onClick={() => setUserModal(false)} sx={{ color: '#fff' }} size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          {/* Body */}
          <Box sx={{ overflowY: 'auto', flex: 1, px: 3, py: 2.5 }}>
            {/* Selected Employees */}
            <Box
              sx={{
                border: `1.5px solid ${errors.employee ? '#d32f2f' : TEAL_MID}`,
                borderRadius: 2,
                p: 2,
                mb: errors.employee ? 0.5 : 2.5,
                backgroundColor: errors.employee ? '#fff5f5' : TEAL_LIGHT,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: formData.employee.length ? 1.5 : 0 }}>
                <PeopleAltIcon sx={{ fontSize: 16, color: TEAL_DARK }} />
                <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: TEAL_DARK }}>
                  Selected Employees
                </Typography>
                <Chip
                  label={formData.employee.length}
                  size="small"
                  sx={{ height: 18, fontSize: '0.7rem', backgroundColor: TEAL_DARK, color: '#fff', fontWeight: 700 }}
                />
              </Box>
              {formData.employee.length > 0 && (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                  {formData.employee.map((item, index) => (
                    <Chip
                      key={index}
                      label={`${item.first_name} ${item.last_name}`}
                      onDelete={() => handleDelete(item)}
                      size="small"
                      sx={{
                        backgroundColor: '#fff',
                        border: `1px solid ${TEAL_MID}`,
                        color: TEAL_DARK,
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        '& .MuiChip-deleteIcon': { color: TEAL_MID, '&:hover': { color: TEAL_DARK } },
                      }}
                    />
                  ))}
                </Box>
              )}
            </Box>

            {errors.employee && (
              <FormHelperText error sx={{ mb: 2, ml: 0.5 }}>
                {errors.employee}
              </FormHelperText>
            )}

            {/* Form Fields */}
            <Grid container spacing={2}>
              {/* Left column: Planned Date → Group Number → Sequence Number */}
              <Grid item xs={12} sm={6}>
                <Stack spacing={2}>
                  {/* Planned Date */}
                  <Box>
                    <Typography sx={{ ...fieldLabelSx, color: errors.plannedDate ? '#d32f2f' : '#555' }}>
                      Planned Date
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData.plannedDate ?? ''}
                        onChange={(newValue) => {
                          handleChange('plannedDate', newValue);

                          if (newValue) {
                            setErrors((prev) => ({
                              ...prev,
                              plannedDate: undefined,
                            }));
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            size="small"
                            error={!!errors.plannedDate}
                            helperText={errors.plannedDate}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Box>

                  {/* Group Number & Sequence Number — side by side */}
                  <Box sx={{ display: 'flex', gap: 1.5 }}>
                    {/* Group Number */}
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{ ...fieldLabelSx, color: errors.groupNumber ? '#d32f2f' : '#555' }}>
                        Group Number
                      </Typography>
                      <FormControl fullWidth size="small" error={!!errors.groupNumber}>
                        <Select
                          value={formData.groupNumber ?? ''}
                          onChange={(e) => handleChange('groupNumber', e.target.value)}
                          sx={{ '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: TEAL } }}
                        >
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                            <MenuItem key={n} value={n}>
                              {n}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.groupNumber && <FormHelperText>{errors.groupNumber}</FormHelperText>}
                      </FormControl>
                    </Box>

                    {/* Sequence Number */}
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{ ...fieldLabelSx, color: errors.sequenceNumber ? '#d32f2f' : '#555' }}>
                        Sequence Number
                      </Typography>
                      <FormControl fullWidth size="small" error={!!errors.sequenceNumber}>
                        <Select
                          value={formData.sequenceNumber ?? ''}
                          onChange={(e) => handleChange('sequenceNumber', e.target.value)}
                          sx={{ '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: TEAL } }}
                        >
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                            <MenuItem key={n} value={n}>
                              {n}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.sequenceNumber && <FormHelperText>{errors.sequenceNumber}</FormHelperText>}
                      </FormControl>
                    </Box>
                  </Box>
                </Stack>
              </Grid>

              {/* Right column: icons aligned to the Planned Date input */}
              <Grid item xs={12} sm={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, pt: '22px' }}>
                  {dayGroupKeys.length > 0 && (
                    <Tooltip title={`${dayGroupKeys.length} group(s) scheduled on this date`} arrow placement="top">
                      <IconButton
                        size="small"
                        onClick={() => setDaySchedulePopup(true)}
                        sx={{
                          color: '#3DADB5',
                          backgroundColor: '#E0F6F8',
                          '&:hover': { backgroundColor: '#b2ebf2' },
                          borderRadius: '6px',
                          p: '5px',
                        }}
                      >
                        <ViewListIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                  {dateLeaves.length > 0 && (
                    <Tooltip title={`${dateLeaves.length} leave(s) on this date`} arrow placement="top">
                      <IconButton
                        size="small"
                        onClick={() => setLeaveModal({ open: true })}
                        sx={{
                          color: '#F59E0B',
                          backgroundColor: '#FEF3C7',
                          '&:hover': { backgroundColor: '#FDE68A' },
                          borderRadius: '6px',
                          p: '5px',
                        }}
                      >
                        <EventBusyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                  {datePrebookings.length > 0 && (
                    <Tooltip title={`${datePrebookings.length} prebooking(s) on this date`} arrow placement="top">
                      <IconButton
                        size="small"
                        onClick={() => setPrebookingModal({ open: true })}
                        sx={{
                          color: '#7C3AED',
                          backgroundColor: '#EDE9FE',
                          '&:hover': { backgroundColor: '#DDD6FE' },
                          borderRadius: '6px',
                          p: '5px',
                        }}
                      >
                        <BookOnlineIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              </Grid>

              {/* Employees Select */}
              <Grid item xs={12}>
                <Typography sx={{ ...fieldLabelSx, color: errors.employee ? '#d32f2f' : '#555' }}>Employees</Typography>
                <FormControl fullWidth size="small" error={!!errors.employee}>
                  <Select
                    multiple
                    value={selected_employees}
                    onChange={(e) => {
                      const selectedIds = e.target.value;
                      const selectedEmps = employees
                        .filter((emp) => selectedIds.includes(emp.id))
                        .map((emp) => ({ ...emp, _id: emp.id }));
                      setFormData({ ...formData, employee: selectedEmps });
                      checkEmployeeLeave(selectedEmps);
                      if (selectedEmps.length > 0) setErrors({ ...errors, employee: undefined });
                      checkConflict(
                        selectedEmps,
                        formData.plannedDate,
                        formData.groupNumber,
                        formData.sequenceNumber,
                        formData.estimatedHours,
                        formData.costItem
                      );
                    }}
                    renderValue={() =>
                      formData.employee
                        .map((emp) => `${emp.first_name} ${emp.last_name}`)
                        .slice(0, 2)
                        .join(', ') + (formData.employee.length > 2 ? ' ...' : '')
                    }
                    sx={{ '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: TEAL } }}
                  >
                    {employees.map((emp) => (
                      <MenuItem key={emp.id} value={emp.id}>
                        <Checkbox
                          checked={selected_employees.includes(emp.id)}
                          sx={{ color: TEAL, '&.Mui-checked': { color: TEAL_DARK } }}
                        />
                        <ListItemText primary={`${emp.first_name} ${emp.last_name}`} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {leaveWarning.length > 0 && (
                  <Alert severity="warning" sx={{ mt: 1 }}>
                    {leaveWarning.map((emp) => `${emp.first_name} ${emp.last_name}`).join(', ')}
                    {leaveWarning.length > 1 ? ' are' : ' is'} on leave for the selected date.
                  </Alert>
                )}
              </Grid>

              <Grid item xs={12}>
                <Divider sx={{ borderColor: TEAL_LIGHT }} />
              </Grid>

              {/* Task Scope */}
              <Grid item xs={12} sm={6}>
                <Typography sx={{ ...fieldLabelSx, color: errors.taskScope ? '#d32f2f' : '#555' }}>
                  Task Scope
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  value={formData.taskScope ?? ''}
                  disabled
                  error={!!errors.taskScope}
                  helperText={errors.taskScope}
                  placeholder="Auto-filled from task"
                  sx={{
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: TEAL },
                  }}
                />
              </Grid>

              {/* Cost Item */}
              <Grid item xs={12} sm={6}>
                <Typography sx={{ ...fieldLabelSx, color: errors.costItem ? '#d32f2f' : '#555' }}>Cost Item</Typography>
                <FormControl fullWidth size="small" error={!!errors.costItem}>
                  <Select
                    value={formData.costItem ?? ''}
                    onChange={(e) => handleChange('costItem', e.target.value)}
                    sx={{ '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: TEAL } }}
                  >
                    {costItems.map((item) => (
                      <MenuItem key={item} value={item}>
                        <ListItemText primary={item} />
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.costItem && <FormHelperText>{errors.costItem}</FormHelperText>}
                </FormControl>
              </Grid>

              {/* Estimated Hours */}
              <Grid item xs={12} sm={6}>
                <Typography sx={{ ...fieldLabelSx, color: errors.estimatedHours ? '#d32f2f' : '#555' }}>
                  Estimated Hours
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  inputProps={{ min: 0, step: 0.5 }}
                  value={formData.estimatedHours ?? ''}
                  onChange={(e) => handleChange('estimatedHours', e.target.value)}
                  error={!!errors.estimatedHours}
                  helperText={errors.estimatedHours}
                  sx={{
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: TEAL },
                  }}
                />
              </Grid>

              {/* Document Link (optional) */}
              <Grid item xs={12}>
                <Typography sx={fieldLabelSx}>
                  Document Link <span style={{ fontWeight: 400, color: '#999', fontSize: '0.72rem' }}>(optional)</span>
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="url"
                  value={formData.documentLink ?? ''}
                  onChange={(e) => handleChange('documentLink', e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: TEAL },
                  }}
                />
              </Grid>

              {/* Description (optional) */}
              <Grid item xs={12}>
                <Typography sx={fieldLabelSx}>
                  Description <span style={{ fontWeight: 400, color: '#999', fontSize: '0.72rem' }}>(optional)</span>
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  multiline
                  rows={3}
                  value={formData.description ?? ''}
                  onChange={(e) => handleChange('description', e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: TEAL },
                  }}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Footer */}
          <Box
            sx={{
              px: 3,
              py: 2,
              borderTop: `1px solid ${TEAL_LIGHT}`,
              backgroundColor: '#fafafa',
              flexShrink: 0,
            }}
          >
            <Stack direction="row" spacing={1.5} justifyContent="space-between" alignItems="center">
              <Button
                size="small"
                variant={commentCount > 0 ? 'contained' : 'text'}
                startIcon={<CommentIcon sx={{ fontSize: '14px !important' }} />}
                onClick={() => setCommentModal(true)}
                sx={
                  commentCount > 0
                    ? {
                      backgroundColor: '#65C8D0',
                      color: '#fff',
                      textTransform: 'none',
                      fontWeight: 700,
                      fontSize: '0.75rem',
                      '&:hover': { backgroundColor: '#3DADB5' },
                    }
                    : {
                      color: TEAL_DARK,
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '0.75rem',
                      '&:hover': { backgroundColor: TEAL_LIGHT },
                    }
                }
              >
                Comments{commentCount > 0 ? ` (${commentCount})` : ''}
              </Button>
              <Stack direction="row" spacing={1.5}>
                {linkedDraft && (
                  <Button
                    variant="outlined"
                    color="warning"
                    onClick={handleUnlinkDraft}
                    sx={{
                      borderColor: '#d32f2f',
                      color: '#d32f2f',
                      fontWeight: 700,
                      textTransform: 'none',
                      '&:hover': {
                        borderColor: '#b71c1c',
                        color: '#b71c1c',
                        backgroundColor: '#ffebee',
                      },
                    }}
                  >
                    Unlink Draft
                  </Button>
                )}
                <Button
                  variant="outlined"
                  onClick={() => setUserModal(false)}
                  sx={{
                    borderColor: TEAL_MID,
                    color: TEAL_DARK,
                    '&:hover': { borderColor: TEAL_DARK, backgroundColor: TEAL_LIGHT },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    if (!validate()) return;

                    const halfCrewWarning = formData.costItem === '1/2 Survey Crew' && formData.employee.length !== 2;

                    const multipleEmployeeWarning =
                      formData.costItem !== '1/2 Survey Crew' && formData.employee.length > 1;

                    const hasWarnings =
                      conflictWarning ||
                      hoursWarning ||
                      sequenceWarning ||
                      groupHoursWarning ||
                      halfCrewWarning ||
                      multipleEmployeeWarning;

                    if (hasWarnings) {
                      setConfirmOpen(true);
                    } else {
                      doSave();
                    }
                  }}
                  sx={{
                    backgroundColor: TEAL_DARK,
                    '&:hover': { backgroundColor: TEAL },
                    fontWeight: 700,
                    px: 3,
                  }}
                >
                  Save
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Box>
      </Modal>

      {/* Warning Confirmation Dialog */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2, overflow: 'hidden' } }}
      >
        <Box
          sx={{
            background: `linear-gradient(135deg, ${TEAL} 0%, ${TEAL_DARK} 100%)`,
            px: 2.5,
            py: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '0.95rem' }}>Warnings</Typography>
          <IconButton size="small" onClick={() => setConfirmOpen(false)} sx={{ color: '#fff' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ px: 2.5, py: 2, display: 'flex', flexDirection: 'column', gap: 1.25 }}>
          <Typography sx={{ fontSize: '0.82rem', color: '#555', mb: 0.5 }}>
            The following warnings were detected. Do you still want to save?
          </Typography>

          {formData.costItem === '1/2 Survey Crew' && formData.employee.length !== 2 && (
            <Alert severity="warning" sx={{ fontSize: '0.8rem', py: 0.5 }}>
              1/2 Survey Crew requires exactly 2 employees.
            </Alert>
          )}

          {formData.costItem !== '1/2 Survey Crew' && formData.employee.length > 1 && (
            <Alert severity="warning" sx={{ fontSize: '0.8rem', py: 0.5 }}>
              This cost item usually allows only 1 employee, but multiple employees are selected.
            </Alert>
          )}

          {conflictWarning && (
            <Alert severity="warning">
              {conflictWarning.length === 1
                ? `${conflictWarning[0]} is already assigned to another group on the selected date.`
                : `${conflictWarning.join(', ')} are already assigned to other groups on the selected date.`}
            </Alert>
          )}
          {hoursWarning && (
            <Alert severity="warning" sx={{ fontSize: '0.8rem', py: 0.5 }}>
              {hoursWarning.length === 1
                ? `${hoursWarning[0]} is already allocated for 8 hours for the current day.`
                : `${hoursWarning.join(', ')} are already allocated for 8 hours for the current day.`}
            </Alert>
          )}
          {sequenceWarning && (
            <Alert severity="warning" sx={{ fontSize: '0.8rem', py: 0.5 }}>
              The selected sequence number is already assigned within the same group for the current day.
            </Alert>
          )}
          {groupHoursWarning && (
            <Alert severity="warning" sx={{ fontSize: '0.8rem', py: 0.5 }}>
              The selected group has already been allocated 8 hours for the current day.
            </Alert>
          )}
        </Box>

        <Box
          sx={{
            px: 2.5,
            py: 1.5,
            borderTop: `1px solid ${TEAL_LIGHT}`,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1.5,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setConfirmOpen(false)}
            sx={{
              borderColor: TEAL_MID,
              color: TEAL_DARK,
              '&:hover': { borderColor: TEAL_DARK, backgroundColor: TEAL_LIGHT },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={doSave}
            sx={{ backgroundColor: TEAL_DARK, '&:hover': { backgroundColor: TEAL }, fontWeight: 700, px: 3 }}
          >
            Ok, Save
          </Button>
        </Box>
      </Dialog>
      <TodoDraftUpdateModal
        open={todoDraftModal}
        onClose={() => {
          setTodoDraftModal(false);
          setUserModal(false);
        }}
        schedule={schedule}
        initialCostItem={todoDraftData.costItem}
        initialEstimatedHours={todoDraftData.estimatedHours}
        initialFieldTripDate={todoDraftData.fieldTripDate}
        initialDescription={todoDraftData.description}
        status="ready for drafting"
        onSubmit={(response) => {
          setTodoDraftModal(false);

          if (
            response?.statusCode === 200 &&
            response?.message === 'Todo Draft updated successfully'
          ) {
            onRefresh?.();
            showScheduleAndDraftSuccess();
          }
        }}
      />
      <MessageDialog
        open={messageDialog.open}
        title={messageDialog.title}
        severity={messageDialog.severity}
        message={messageDialog.message}
        okText={messageDialog.okText || 'OK'}
        cancelText={messageDialog.cancelText}
        onConfirm={() => {
          if (messageDialog.onConfirm) {
            messageDialog.onConfirm();
          } else {
            setMessageDialog(resetMessageDialog());
          }
        }}
        onCancel={() => {
          if (messageDialog.onCancel) {
            messageDialog.onCancel();
          } else {
            setMessageDialog(resetMessageDialog());
          }
        }}
        onClose={() =>
          setMessageDialog({
            open: false,
            title: '',
            message: '',
            onConfirm: null,
            onCancel: null,
          })
        }
      />
      <Backdrop
        open={savingSchedule}
        sx={{
          zIndex: (theme) => theme.zIndex.modal + 10,
          color: '#fff',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <CircularProgress color="inherit" />
        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          Saving schedule...
        </Typography>
      </Backdrop>
    </>
  );
}

AssignUserModel.propTypes = {
  opentStatus: PropTypes.bool.isRequired,
  setUserModal: PropTypes.func.isRequired,
  employees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
    })
  ).isRequired,
  schedule: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    group_number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sequence_number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    task_scope_id: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string })]),
    cost_item: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    planned_date: PropTypes.string,
    document_link: PropTypes.string,
    description: PropTypes.string,
    comments: PropTypes.array,
    assigned_members: PropTypes.array,
    estimated_hours: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    task: PropTypes.shape({ _id: PropTypes.string, number_str: PropTypes.string }),
    job_id: PropTypes.shape({ number_str: PropTypes.string }),
  }).isRequired,
  handleUserAssign: PropTypes.func.isRequired,
  allSchedules: PropTypes.array,
  onRefresh: PropTypes.func,
};

export default AssignUserModel;